import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { usePostHog } from "posthog-js/react";

import { useCarrierShipmentPageContext, useRoleContext } from "hooks";
import { carrierHasBookingWriteAccess } from "utils";

import { ClientAppEvent } from "../../../../../../constants";

interface Props {
  open: boolean;
  handleDrawerClose: () => void;
  onShareBookingWithTeammatesOpen: () => void;
  onOpenPdfPreview: () => void;
}

export function CarrierSideBarMenu(props: Props) {
  const { shipment } = useCarrierShipmentPageContext();
  const { role } = useRoleContext();
  const posthog = usePostHog();
  const {
    open,
    handleDrawerClose,
    onShareBookingWithTeammatesOpen,
    onOpenPdfPreview,
  } = props;

  const handleShareBookingClick = () => {
    if (shipment) {
      posthog?.capture(ClientAppEvent.CARRIER_BOOKING_SHARE_BUTTON_CLICKED, {
        shipment_id: shipment.info.id,
        triggered_by_role: role?.id,
      });
    }
    onShareBookingWithTeammatesOpen();
  };

  if (!shipment || shipment === undefined) {
    return null;
  }

  return (
    <Drawer variant="persistent" anchor="right" open={open}>
      <div>
        <IconButton onClick={handleDrawerClose}>
          <ChevronRightIcon />
        </IconButton>
      </div>
      <List>
        {shipment?.carrier_access_type === "BOOKED_QUOTE_OWNER" && (
          <ListItem>
            <Tooltip
              title="Share this booking with teammates in your company to grant them full access"
              placement="left"
            >
              <ListItemButton onClick={handleShareBookingClick}>
                <ListItemIcon>
                  <PersonAddIcon />
                </ListItemIcon>
                <ListItemText primary="Share Booking with Teammate" />
              </ListItemButton>
            </Tooltip>
          </ListItem>
        )}
        {shipment &&
          carrierHasBookingWriteAccess(shipment) &&
          (shipment.shipment_status === "BOOKED" ||
            shipment.shipment_status === "DELIVERED" ||
            shipment.shipment_status === "PICKED_UP") && (
            <ListItem>
              <Tooltip
                title={
                  shipment.info.type === "MULTI_SHIPMENT_PROJECT"
                    ? "Export is only supported for single shipments"
                    : ""
                }
                placement="left"
              >
                <ListItemButton
                  onClick={onOpenPdfPreview}
                  disabled={shipment.info.type === "MULTI_SHIPMENT_PROJECT"}
                >
                  <ListItemIcon>
                    <PictureAsPdfIcon />
                  </ListItemIcon>
                  <ListItemText primary="Export PDF" />
                </ListItemButton>
              </Tooltip>
            </ListItem>
          )}
      </List>
    </Drawer>
  );
}
